import EventBus from '@/js/util/EventBus'
import filter from '@/js/util/symbols/filter'

export default {
  name: 'BaseFilterCheckbox',
  inject: { filter },
  props: {
    type: {
      type: String,
      default: null,
    },

    // props below this message are
    // for rowan api delete after project
    item: {
      type: Object,
      default: () => ({}),
    },

    filterKey: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      checked: false,
      slot: this.$slots.default,
    }
  },

  created() {
    this.filter.$emit('create:checkboxes', this)
    EventBus.$on('uncheck:checkboxes', (checked) => {
      this.$refs[this.$options.name].checked = false
      this.checkCheckbox(checked)
    })
  },

  computed: {
    activeCheckbox() {
      return this.filter.activeCheckbox === this
    },
  },

  watch: {
    checked() {
      this.filter.$emit('set:checkbox', this)
    },
  },

  methods: {
    checkCheckbox(checked) {
      this.checked = checked
    },
    handleChange() {
      this.checkCheckbox(!this.checked)
    },

    createChild(createElement) {
      const elementData = {
        ref: this.$options.name,
        staticClass: this.$options.name,
        on: {
          change: this.handleChange,
        },
        attrs: {
          type: 'checkbox',
          name: this.type || null,
          'aria-checked': this.checked.toString(),
        },
      }
      return createElement('input', elementData)
    },
  },

  render(createElement) {
    const activeClass = { class: { active: this.activeCheckbox, checked: this.checked } }
    return createElement('label', activeClass, [this.createChild(createElement), this.slot])
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseFilterCheckbox.js